import { statisticApi } from '@api/index';
import { QUERIES } from '@query/queries';
import { useQuery } from 'react-query';

export const useSyncFuturesDealsQuery = () => {
  return useQuery([QUERIES.FUTURES_DEALS_SYNC], () => statisticApi.syncDeals());
};
